import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { HOME_BY_ROLE } from "@/components/ProtectedRoute";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { googleLogin } = useAuth();
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { navigate("/login"); return; }
    googleLogin(decodeURIComponent(m[1]))
      .then((data) => {
        window.history.replaceState(null, "", window.location.pathname);
        if (data.needs_role) { navigate("/choose-role"); return; }
        toast.success(`Welcome, ${data.user.name.split(" ")[0]}!`);
        navigate(HOME_BY_ROLE[data.user.role] || "/app/home");
      })
      .catch(() => { toast.error("Google sign-in failed. Please try again."); navigate("/login"); });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-[#0b0a1f] text-white/70">
      <Sparkles className="h-8 w-8 animate-pulse text-fuchsia-400" />
      <p className="text-sm">Signing you in…</p>
    </div>
  );
}
